<script type="ts">
    import axios from 'axios';

    import { reloadToken, token } from '../stores/user';

    import InputText from './design/InputText.svelte';
    import InputPassword from './design/InputPassword.svelte';
    import { onMount } from 'svelte';

    let loginError = false;

    let userNameInput: '';
    let userNameValid: boolean;
    let passwordInput: '';
    let passwordValid: boolean;

    onMount(() => reloadToken());

    function handleLogin()
    {
        if (!userNameValid || !passwordValid)
        {
            return;
        }

        const data = {
            userName: userNameInput,
            password: passwordInput,
        };

        axios.post<string>('/umbraco/api/mynemi/authentication', data)
            .then((ticket) =>
            {
                if (ticket.data != null && ticket.data.length !== 0)
                {
                    token.set(ticket.data);
                }
                else
                {
                    loginError = true;
                }
            })
            .catch(() =>
            {
                loginError = true;
            });
    }
</script>

<div class="row">
    <div class="col"><h2>Veuillez entrer vos informations d'accès</h2></div>
</div>
<div class="row justify-content-center pt-5">
    <div class="col-12 col-md-6">
        <InputText text="Nom d'utilisateur" bind:value={userNameInput} bind:isValid={userNameValid} type={"text"} required={true}/>
    </div>
</div>
<div class="row justify-content-center">
    <div class="col-12 col-md-6">
        <InputPassword text="Mot de passe" bind:value={passwordInput} bind:isValid={passwordValid} required={true}/>
    </div>
</div>
<div class="row justify-content-center">
    <div class="col-12 col-md-6">
        <button type="submit" class="col-12 btn btn-primary" on:click={handleLogin}>Se connecter</button>
    </div>
</div>

{#if loginError}
    <div class="row justify-content-center pt-2">
        <div class="col-12 alert alert-danger">
            Vos identifiants n'ont pas été reconnus. Merci de vérifer.<br/>
            <i>Les identifiants à utiliser sont ceux de l'espace e-learning.</i>
        </div>
    </div>
{/if}
